var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"public-welfare-content"},[_vm._m(0),_c('public-china-map')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('h3',[_vm._v("暖峰行动捐助地图")]),_c('div',{staticClass:"tip"},[_vm._v("张雪峰老师和峰学未来的老师们用爱心点亮城市")])])
}]

export { render, staticRenderFns }